import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FEED_SWITCHER';

export const {action: selectInstitutionId} = createAction(`${domain}/SELECT_INSTITUTION_ID`, institutionId => ({
    institutionId,
}));

export const {
    action: fetchFeedInstitutions,
    success: fetchFeedInstitutionsSuccess,
    failed: fetchFeedInstitutionsFailed,
} = createAction(
    `${domain}/FETCH_FEED_INSTITUTIONS`,
    () => ({}),
    institutions => ({institutions}),
);

export const {action: showFeedChooser} = createAction(`${domain}/SHOW_FEED_CHOOSER`, show => ({show}));
